import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import QRCode from "react-qr-code";
import axios from "axios";
import { applicationId, UNO_URL } from "../Server";

const initialDevice = {
  token: null,
  macAddress: null,
  platform: "web",
  deviceType: null,
  appVersion: "0",
  deviceMake: null,
  deviceName: null,
  processor: null,
  ram: null,
  storage: null,
  applicationId: applicationId,
  systemTime: null,
  ssoVersion: "0",
  osVersion: null,
  channelId: null,
  referrerUrl: null,
  redirectUri: null,
  darkMode: true,
};

const ScanQR = ({ show, onHide }) => {
    const user = useSelector((state) => state?.userData);
    const [qrUuid, setQrUuid] = useState(null);

    const generateQrToken = async (token) => {
        setQrUuid(null);
        try {
            const body = {
                device: initialDevice
            };
            let { data } = await axios.post(`${UNO_URL}/api/auth/generate/qr/token/${applicationId}`, body, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
           
            setQrUuid(data?.data?.uuid || null);

        } catch (error) {

        }
    };
    useEffect(() => {
        if (user && user.userDetails && user.userDetails.token) {
            generateQrToken(user.userDetails.token);
        }
    }, [user]);
    if (!user || !user.userDetails) return null;
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Scan QR Code</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ height: "auto", margin: "0 auto", maxWidth: 512, width: "100%" }}>
                    <QRCode
                        size={512}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={JSON.stringify({ 'token': qrUuid })}
                        viewBox={`0 0 256 256`}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ScanQR;
